// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from './http.js'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'styles/reset.css'
// import 'default-passive-events'
import './directive'
import feedBackConfig from './lib/feedBack';
// import ImportNotifyPlugin from 'hyperf-import-notify-ysy01';

Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.use(ImportNotifyPlugin)
Vue.prototype.$axios = axios
Vue.prototype.$feedBackConfig = feedBackConfig

/* eslint-disable no-new */
new Vue({
  el: '#app',
  beforeCreate () {
    Vue.prototype.$bus = this
  },
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js